import { PUBLIC_HOST, INTRANET_HOST, BATCH_REQ_PATH, SINGLE_REQ_PATH } from './const';
/**
 * 判断某个变量是否为对象
 * @param {any} val 判断的对象
 * @return {boolean} 是否为对象
 */
export function isObject(val) {
    return typeof val !== null && typeof val === 'object';
}
/**
 * 判断一个变量是否为 Date 类型
 * @param val val to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
export function isDate(val) {
    return Object.prototype.toString.call(val) === '[object Date]';
}
export var sleep = function (timer) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timer);
    });
};
function encode(val) {
    return encodeURIComponent(val)
        .replace(/%3A/gi, ':')
        .replace(/%24/g, '$')
        .replace(/%2C/gi, ',')
        .replace(/%20/g, '+')
        .replace(/%5B/gi, '[')
        .replace(/%5D/gi, ']');
}
export function serializeParams(params) {
    if (!params)
        return '';
    var parts = [];
    var _loop_1 = function (key) {
        var val = params[key];
        if (val === null || typeof val === 'undefined') {
            return "continue";
        }
        if (Array.isArray(val)) {
            key = key + '[]';
        }
        else {
            val = [val];
        }
        val.forEach(function (value) {
            if (isDate(value)) {
                value = value.toISOString();
            }
            else if (isObject(value)) {
                value = JSON.stringify(value);
            }
            parts.push(encode(key) + '=' + encode(value));
        });
    };
    for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
        var key = _a[_i];
        _loop_1(key);
    }
    return parts.join('&');
}
export function isValidHost(host) {
    var regExp = /https?:\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+/;
    return regExp.test(host);
}
/** 获取下发地址 */
export function getRemoteUrl(requestType, sankuaiOnly, outterHost) {
    var reqPath = requestType === 'batch' ? BATCH_REQ_PATH : SINGLE_REQ_PATH;
    var reqHost;
    if (sankuaiOnly) {
        reqHost = INTRANET_HOST;
    }
    else if (outterHost) {
        reqHost = outterHost;
    }
    else {
        reqHost = PUBLIC_HOST;
    }
    return "" + reqHost + reqPath;
}
//# sourceMappingURL=util.js.map